var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-field',[_c('gl-icon-calendar'),_c('md-input',{ref:"input",attrs:{"type":"text","required":""},on:{"input":_vm.changeDate}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }